var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2"},[_c('div',{staticClass:"control-section"},[_c('div',{staticClass:"col-lg-12 e-img-editor-sample"},[_c('ejs-imageeditor',{ref:"imageEditorObj",attrs:{"theme":_vm.themeValue,"id":"image-editor","created":_vm.created}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }